export default {
  title: 'Notifications',
  createMessage: 'Create message',
};
